module.exports = __webpack_public_path__ + "img/icon11.54d677dd.png";